
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import { SettingsModule } from '@/store/modules/settings';
import Logo from './Logo.vue';

@Component({
  name: 'SideBarAgent',
  components: {
    Logo
  }
})
export default class extends Vue {
  created() {

  }

  get sidebar() {
    return AppModule.sidebar;
  }

  get routes() {
    return (this.$router as any).options.routes;
  }

  get isCollapse() {
    return false;//! this.sidebar.opened
  }

  get showLogo() {
    return SettingsModule.sidebarLogo;
  }
}
